import { render, staticRenderFns } from "./ProgramHistory.vue?vue&type=template&id=2c3e783a&"
import script from "./ProgramHistory.vue?vue&type=script&lang=js&"
export * from "./ProgramHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports